export const CONTROL_TYPE_CHECKLIST = 'checklist';
export const CONTROL_TYPE_SELECT = 'dropdown';
